// domain/usecase/user/GetAssignableEmployeesUseCase.kt
package com.evoapps.evoshift.domain.usecase.user

import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.repository.UserRepository

class GetAssignableEmployeesUseCase(
    private val userRepository: UserRepository
) {
    /**
     * Zwraca listę pracowników, którzy mają aktywny angaż (isActive=true) w danym workplaceId.
     * Używane w dropdownach "Assign to...".
     */
    suspend operator fun invoke(workplaceId: String): Result<List<User>> {
        return userRepository.getAssignableEmployees(workplaceId)
    }
}